import { AbstractControl } from '@angular/forms';
export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
        let password = AC.get('password').value; // get value from password form control
        let passwordRetype = AC.get('passwordRetype').value; // get value from passwordRetype form control
        if(password !== passwordRetype) {
            AC.get('passwordRetype').setErrors( {MatchPassword: true} )
        } else {
            AC.get('passwordRetype').setErrors( null )
        }
    }
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/validators/passwordValidation.validator.ts